import { Directive, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApexOptions } from 'ng-apexcharts';

@Directive()
export abstract class ChartComponentBase implements OnInit {
  @Input() chartDef: any;
  @Input() fillMode = false;
  @Input() isTimeSeries = false;
  @Input() height = null as string;
  @Input() overflowAuto = false;
  @Input() fields: any[] = [];
  @Output() dataPointSelection = new EventEmitter<any>();
  @Output() columnMoved = new EventEmitter<any>();

  chartOptions: ApexOptions;
  defaultColors = [
    '#008FFB',
    '#00E396',
    '#FEB019',
    '#FF4560',
    '#775DD0',
    '#3F51B5',
    '#03A9F4',
    '#4CAF50',
    '#F9CE1D',
    '#FF9800',
    '#33B2DF',
    '#546E7A',
    '#D4526E',
    '#13D8AA',
    '#A5978B',
    '#4ECDC4',
    '#C7F464',
    '#81D4FA',
    '#FD6A6A',
    '#2B908F',
    '#F9A3A4',
    '#90EE7E',
    '#FA4443',
    '#69D2E7',
    '#449DD1',
    '#F86624',
    '#EA3546',
    '#662E9B',
    '#C5D86D',
    '#D7263D',
    '#1B998B',
    '#2E294E',
    '#F46036',
    '#E2C044',
    '#F9C80E',
    '#43BCCD',
    '#5C4742',
    '#8D5B4C',
    '#5A2A27',
    '#C4BBAF',
    '#A300D6',
    '#7D02EB',
    '#5653FE',
    '#2983FF',
    '#00B1F2',
  ];

  ngOnInit(): void {
    this.prepareChart();
  }

  abstract prepareChart(): void;
}

export enum ChartType {
  Donut = 'donut',
  Bar = 'bar',
  HorizontalBar = 'horizontal-bar',
  Line = 'line',
  Metric = 'metric',
  Table = 'table',
}
